import React from 'react';
import { useSelector } from 'react-redux';
import Confirmation from './Confirmation';
import DirectSaleConfirmation from './DirectSaleConfirmation';
import { ShopMode } from '../../redux/types';

export const ConfirmationWrapper: React.FC = () => {
  const shopMode = useSelector((state: any) => state.shopMode.mode);

  return shopMode === ShopMode.DirectSale ? <DirectSaleConfirmation /> : <Confirmation />;
};
